export default "__VITE_ASSET__gGSn2KzX__"